import paper from "@/store/pages/accounts/paper";
import history from "@/store/pages/accounts/history";

export default {
  namespaced: true,
  modules: {
    accounts: {
      namespaced: true,
      modules: {
        paper,
        history
      }
    }
  }
}